export default "__VITE_ASSET__BMnU3K0y__"